var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container form-container" }, [
      _c("div", { staticClass: "row pb-3" }, [
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("div", { staticClass: "clinical-trials-content" }, [
            _c("h2", { class: _vm.post_title_h_style }, [
              _vm._v(_vm._s(_vm.post_title)),
            ]),
            _vm._v(" "),
            _c("div", {
              domProps: { innerHTML: _vm._s(_vm.post_description) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-12 col-md-8" }, [
          _c(
            "form",
            { staticClass: "vue-app", attrs: { id: "event-search-form" } },
            [
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h5", [_vm._v("Filter Events By:")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.form.keyword,
                          expression: "form.keyword",
                        },
                      ],
                      ref: "keyword",
                      staticClass: "form-control",
                      attrs: {
                        id: "keyword",
                        type: "text",
                        placeholder: "Keyword",
                      },
                      domProps: { value: _vm.form.keyword },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(_vm.form, "keyword", $event.target.value)
                        },
                      },
                    }),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("startdate", {
                        attrs: {
                          placeholder: "Start Date",
                          name: "start_date",
                          "clear-button": true,
                          typeable: true,
                        },
                        model: {
                          value: _vm.form.start_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "start_date", $$v)
                          },
                          expression: "form.start_date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("enddate", {
                        attrs: {
                          placeholder: "End Date",
                          name: "end_date",
                          "clear-button": true,
                          typeable: true,
                        },
                        model: {
                          value: _vm.form.end_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "end_date", $$v)
                          },
                          expression: "form.end_date",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-row pt-2" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary mx-1",
                    attrs: { type: "submit" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.searchEvents(true)
                      },
                    },
                  },
                  [_vm._v("Search")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-dark",
                    attrs: { type: "submit" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.resetForm()
                      },
                    },
                  },
                  [_vm._v("Reset Form")]
                ),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container-fluid clip-path-ellipse-concave-square",
        attrs: { id: "events-results-wrap" },
      },
      [
        _c("div", { staticClass: "container py-3" }, [
          _c(
            "div",
            {
              staticClass: "row vue-search-results",
              attrs: { id: "events-results" },
            },
            [
              _vm._l(_vm.events, function (event) {
                return _c("events-results", {
                  key: event["title"],
                  attrs: { event: event },
                })
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-12",
                  class: { "d-none": _vm.total_count || !_vm.initialized },
                },
                [_vm._v(_vm._s(_vm.no_results_message))]
              ),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container py-2", class: { "d-none": _vm.has_more } },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.showCards()
                    },
                  },
                },
                [_vm._v("Load More Results")]
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }